import * as React from 'react'

function SvgResponse(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M22.81 19.165l.333-1.04c.284-.89.439-1.841.439-2.835a9.29 9.29 0 10-9.291 9.291h10.738l-2.22-5.416zm3.19-.127c.378-1.181.582-2.44.582-3.748C26.582 8.502 21.079 3 14.29 3S2 8.502 2 15.29c0 6.788 5.503 12.291 12.29 12.291h13.72a1 1 0 00.925-1.379L26 19.038z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9 12.5a1.5 1.5 0 011.5-1.5h7a1.5 1.5 0 010 3h-7A1.5 1.5 0 019 12.5zM9 17.5a1.5 1.5 0 011.5-1.5h7a1.5 1.5 0 010 3h-7A1.5 1.5 0 019 17.5z"
        fill="currentColor"
      />
    </svg>
  )
}

export default SvgResponse
